import bittoelatings_a from "./bittoelatings_a";
import bittoelatings_b from "./bittoelatings_b";
import bittoelatings_c from "./bittoelatings_c";
import bittoelatings_d from "./bittoelatings_d";
import bittoelatings_e from "./bittoelatings_e";
import bittoelatings_f from "./bittoelatings_f";
import bittoelatings_g from "./bittoelatings_g";
import bittoelatings_h from "./bittoelatings_h";
import bittoelatings_i from "./bittoelatings_i";

var toelatings = [...bittoelatings_a, ...bittoelatings_b, ...bittoelatings_c, ...bittoelatings_d, ...bittoelatings_e, ...bittoelatings_f, ...bittoelatings_g, ...bittoelatings_h, ...bittoelatings_i];

export default toelatings;